import { CommonModule } from '@angular/common';
import {
  AfterViewInit,
  Component,
  ElementRef,
  HostListener,
  OnDestroy,
  Renderer2,
  ViewChild,
} from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { filter, fromEvent, interval, Subscription, take } from 'rxjs';
import Typed, { TypedOptions } from 'typed.js';

@Component({
  selector: 'app-search-banner',
  templateUrl: './search-banner.component.html',
  styleUrls: ['./search-banner.component.less'],
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    RouterModule
  ]
})
export class SearchBannerComponent implements AfterViewInit, OnDestroy {
  isOpen = false;
  query!: string;
  typed!: Typed;
  private isTypedDestroyed = true;

  @ViewChild('searchInput') searchInput!: ElementRef;
  private inputSubscription!: Subscription;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private el: ElementRef,
    private renderer: Renderer2
  ) { }

  navigate(item?) {
    const queryParams = { query: this.query?.trim()?.replace(/\s+/g, ' ') };

    if (item) {
      this.query = '';
      this.router.navigate(['/category', item.value], {
        queryParams: null,
        queryParamsHandling: 'merge',
      });
    } else {
      if (queryParams.query === '') return;
      this.query = '';
      this.router.navigate(['/category'], {
        queryParams: queryParams,
        queryParamsHandling: 'merge',
      });
    }
    this.isOpen = false;
  }

  ngAfterViewInit(): void {
    this.inputSubscription = fromEvent<InputEvent>(this.searchInput.nativeElement, 'input')
      .subscribe((e: InputEvent) => {
        const val = e.data ?? '';
        if (!this.isTypedDestroyed) {
          setTimeout(() => {
            this.query = val;
          }, 100);
        }

        this.stopTypedAnimation();
      });

    fromEvent<KeyboardEvent>(this.searchInput.nativeElement, 'keydown')
      .subscribe((e: KeyboardEvent) => {
        if (e.key === 'Escape') {
          this.isOpen = false;
          this.query = '';
        }
      });
  }

  toggleSearch() {
    this.isOpen = !this.isOpen;

    if (this.isOpen && this.isTypedDestroyed) {
      const options = {
        strings: ['Minecraft', 'RPG', 'Multiplayer', 'Strategy'],
        typeSpeed: 50,
        backSpeed: 25,
        loop: true,
        showCursor: true,
        onBegin: () => {
          const focusSubscription = interval(100).pipe(
            filter(() => !!this.searchInput.nativeElement),
            take(1)
          ).subscribe(() => {
            this.searchInput.nativeElement.focus()
            focusSubscription.unsubscribe();
          });
        },
      } as TypedOptions;

      this.typed = new Typed('#search-input', options);
      this.isTypedDestroyed = false;
    }
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent) {
    const clickedInside = this.el.nativeElement.contains(event.target);
    if (!clickedInside && this.isOpen) {
      this.isOpen = false;
      this.query = '';
      this.stopTypedAnimation();
    }
  }

  ngOnDestroy(): void {
    this.stopTypedAnimation();
    if (this.inputSubscription) {
      this.inputSubscription.unsubscribe();
    }
  }

  private stopTypedAnimation(): void {
    if (this.typed && !this.isTypedDestroyed) {
      this.typed.destroy();
      this.isTypedDestroyed = true;
    }
  }
}
